import React, { useState, useEffect } from 'react';

import selectVenueById from 'helpers/selectVenueById';

import injectComponent from 'helpers/injectComponent';


import selectLinkedSection from 'helpers/selectLinkedSection';

import {
  fnSetStyling
} from './helpers';

export default function RendererComponent(props) {

  const {
    section,
    templateSchema,
    language = 'en',
    pageSlug,
    secondSlug,
    chapterSlug,
    params,
    windowWidth,
    currentPage,
    thisSectionData,
    indexSection
  } = props;

  const {
    pages,
    agenda,
    presentations,
    navigations,
    streams,
    speakers,
    companies,
    venues,
    forms,
    savedSections,
    organizationId,
    templateId,
    title,
    dateFrom,
    dateTo,
    defaultVenue,
    logo,
    tickets,
    subscriptions,
    calendars,
    customStyles,
    faviconImage,
    dateToWithTime,
    dateFromWithTime,
    presentationTags,
    eventTags
  } = templateSchema;

  const [sectionRender, setSectionRender] = useState('');
  const [thisSectionSelect, setThisSectionSelect] = useState(selectLinkedSection(savedSections, thisSectionData.sectionIdLinked ? thisSectionData.sectionIdLinked : thisSectionData.sectionId, thisSectionData));
  const getSectionData = thisSectionSelect.section ? thisSectionSelect.section : thisSectionSelect;


  useEffect(() => {
    const fetchComponent = async () => {

      const defaultValues = {
        title: title,
        dateFrom: dateFrom,
        dateTo: dateTo,
        dateToWithTime: dateToWithTime,
        dateFromWithTime: dateFromWithTime,
        timezone: templateSchema.timezone,
        twitterAccount: templateSchema.twitterAccount,
        facebookAccount: templateSchema.facebookAccount,
        linkedinAccount: templateSchema.linkedinAccount,
        instagramAccount: templateSchema.instagramAccount,
        slackAccount: templateSchema.slackAccount,
        city: templateSchema.city,
        isOnline: templateSchema.isOnline,
      };

      const agendaData = {
        presentations: presentations,
        agenda: agenda,
      }



      const selectVenue = defaultVenue ? selectVenueById(venues, defaultVenue) : '';
      if (selectVenue) defaultValues.defaultVenueData = selectVenue;
    
      if (getSectionData && (getSectionData.type === 'agenda' || getSectionData.type === 'agendaStacked')) getSectionData.availableTags = presentationTags;
      if (getSectionData && getSectionData.type === 'calendar') getSectionData.availableTags = eventTags;
      
      const thisComponent = await injectComponent(getSectionData.type, getSectionData.componentName, 'component');

      const setStyling = await fnSetStyling(getSectionData, thisSectionSelect, customStyles);

      const commonProps = {
        language: language,
        styling: await setStyling,
        pages: pages ? pages.map((thisPage) => {
          return {
            title: thisPage.title,
            slug: thisPage.slug,
            pageId: thisPage.pageId
          }
        }) : [],
        timezone: templateSchema.timezone,
        baseUrlTamplate: pageSlug === 'location' && secondSlug ? '/location/'+secondSlug : chapterSlug ? '/location/'+chapterSlug : '',
        logo: logo,
        params: params,
        savedSections: savedSections,
        windowWidth: windowWidth,
        faviconImage: faviconImage,
        viewRef: '#PublicViewEventWrapper-id',
      };

      const commonData = {
        componentPayload: getSectionData,
        styling:  setStyling,
        pageIdLinked: section.pageIdLinked,
        sectionIdLinked: section.sectionIdLinked,
        sectionId: section.sectionId,
        organizationId: organizationId,
        templateId: templateId,
        pageId: currentPage.pageId,
        customStyles: customStyles,
        renderSync: getSectionData.type === 'navigation'
      };

      if (thisComponent) {

        const {
          type
        } = thisSectionSelect;


        if (type === 'insights') {
          if (speakers && speakers.length) defaultValues.speakerLength = speakers.length;
          if (companies && companies.length) defaultValues.companiesLength = companies.length;
          if (agendaData && agendaData.agenda && agendaData.agenda.length) defaultValues.daysLength = agendaData.agenda.length;
          defaultValues.attendeesLength = speakers && speakers.length ? speakers.length : 0;


          defaultValues.attendeesLength = speakers && speakers.length ? speakers.length : 0;

          if (tickets && tickets.length) {
            for (let index = 0; index < tickets.length; index++) {
              const element = tickets[index];
              if (element.numberSold) defaultValues.attendeesLength = defaultValues.attendeesLength + element.numberSold;
            }
          }
        }

        setSectionRender(
          {
            component: thisComponent,
            commonProps: commonProps,
            commonData: commonData,
            agendaData: type === 'agenda' || type.toLowerCase() === 'miniagenda' || type === 'agendaStacked' || type === 'speaker' ? agendaData : null,
            presentations: type === 'speaker' ? presentations : null,
            tickets: type === 'tickets' ? getSectionData.tickets : null,
            ticketsData: type === 'tickets' || type === 'workshop' ? tickets : null,
            presentationsData: type === 'workshop' ? presentations : null,
            subscriptions: type === 'subscriptions' ? getSectionData.subscriptions : null,
            subscriptionsData: type === 'subscriptions' ? subscriptions : null,
            navigationId: type === 'navigation' ? getSectionData.navigationId : null,
            navigations: type === 'navigation' ? navigations : null,
            speakers: type === 'speakers' || type === 'agenda' || type.toLowerCase() === 'miniagenda' || type === 'speaker' || type === 'workshop'|| type === 'agendaStacked' ? speakers : null,
            companies: type === 'partners' || type === 'speakers' || type === 'agenda' || type.toLowerCase() === 'miniagenda'|| type === 'agendaStacked' ? companies : null,
            forms: type === 'form' ? forms : null,
            calendars: type === 'calendar' ? calendars : null,
            streams: type === 'stream' ? streams : null,
            venues: type === 'venue' ? venues : null,
            defaultVenue: type === 'venue' ? defaultVenue : null,
            defaultValues: defaultValues,
            viewRef: '#PublicViewEventWrapper-id',
          }
        );
          
      }

      return null;

    }
    fetchComponent();

  }, [windowWidth]);


  useEffect(() => {
    // if not a hash link, scroll to top
    const elementId = sectionRender?.commonData?.componentPayload.hashId || window.location.hash === sectionRender?.commonData?.componentPayload.sectionId;
    if (window.location.hash.replace('#', '') === elementId) {
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView();
        }
      }, 1);
    }
  }, [sectionRender]);

  const ThisComponent = sectionRender && sectionRender?.component ? window.injectCache.get(sectionRender.component) : '';

  return sectionRender?.component && ThisComponent?.default ? (
    <ThisComponent.default
      {...sectionRender}
    />
  ) : '';

}